// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Percent48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Percent48: FC<Percent48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M14.495 21c-1.797 0-3.328-.635-4.595-1.905S8 16.292 8 14.495c0-1.797.635-3.328 1.905-4.595s2.803-1.9 4.6-1.9c1.797 0 3.328.635 4.595 1.905s1.9 2.803 1.9 4.6c0 1.797-.635 3.328-1.905 4.595s-2.803 1.9-4.6 1.9Zm0-3c.97 0 1.797-.34 2.48-1.02.683-.678 1.025-1.504 1.025-2.474 0-.97-.34-1.798-1.02-2.481-.678-.683-1.504-1.025-2.474-1.025-.97 0-1.798.34-2.481 1.02-.683.678-1.025 1.504-1.025 2.474 0 .97.34 1.798 1.02 2.481.678.683 1.504 1.025 2.474 1.025Zm19 22c-1.797 0-3.328-.635-4.595-1.905s-1.9-2.803-1.9-4.6c0-1.797.635-3.328 1.905-4.595s2.803-1.9 4.6-1.9c1.797 0 3.328.635 4.595 1.905s1.9 2.803 1.9 4.6c0 1.797-.635 3.328-1.905 4.595s-2.803 1.9-4.6 1.9Zm0-3c.97 0 1.797-.34 2.48-1.02.683-.678 1.025-1.503 1.025-2.474 0-.97-.34-1.798-1.02-2.481-.678-.683-1.503-1.025-2.474-1.025-.97 0-1.798.34-2.481 1.02-.683.678-1.025 1.503-1.025 2.474 0 .97.34 1.798 1.02 2.481.678.683 1.503 1.025 2.474 1.025ZM10.1 40 8 37.9 37.9 8l2.1 2.1L10.1 40Z" />
        </svg>
    );
};

export default Percent48;
